import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./AdminRegion.module.css";
// import plus from "../../../../Assets/plus.svg"
import { FaEdit, FaPen } from 'react-icons/fa';
// import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table } from 'react-bootstrap';
import HeaderNav from "../../FixedAssetReport/AdminNav/FixedAdminNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
// "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import FixedAdminNav from "../../FixedAssetReport/AdminNav/FixedAdminNav";
// import ToggleSlider from "./ToggleSlider";
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import FixedAssetNav from "../../Accoungting/HeaderNav/FixedAssetNav";

const AdminRegion = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permId, setPermId] = useState([]);
  const [roleID, setRoleID] = useState([]);
  const [permLoading, setPermLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [roleStates, setRoleStates] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [roleCheckAll, setRoleCheckAll] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [selectedProvinceModal, setSelectedProvinceModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areaLoad, setAreaLoad] = useState(false);
  const [areas, setAreas] = useState([]);

  const [responseData, setResponseData] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [continentName, setContinentName] = useState(null);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [regionName, setRegionName] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [provinceName, setProvinceName] = useState(null);
  const [processLoading, setProcessLoading] = useState(false);
  const [processLoading1, setProcessLoading1] = useState(false);
  const [fetchMode, setFetchMode] = useState('default'); // 'default' or 'area'
const [description1, setDescription1] = useState('')
    const [selectedContinent1, setSelectedContinent1] = useState('');
    const [eyeClicked, setEyeClicked] = useState(false);
    const [show, setShow] = useState(false);
      const [createRegionLoading, setCreateRegionLoading] = useState(false);
const handleClose = () => setShow(false);

  const [newUser, setNewUser] = useState({
    fullName: "",
    email: "",
    username: "",
    role: "",
    password: "",
    confirmPassword: ""
  });

  // Print View handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/User');
  };

  

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
      const conName = await localStorage.getItem('continent');
      const proName = await localStorage.getItem('province');
      const regName = await localStorage.getItem('region');

      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (conName !== null) {
        setContinentName(conName);
      }
      if (proName !== null) {
        setProvinceName(proName);
      }
      if (regName !== null) {
        setRegionName(regName);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

 

  const searchUsers = async (searchQuery, page = 1) => {
    if (!bearer) {
      return;
    }

    setSearchLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.get(`${BASE_URL}/users/search`, {
        headers,
        params: {
          variable: searchQuery,
          page: page
        }
      });

      console.log('Search API Response:', response);

      let usersData = [];
      let total = 0;
      let lastPage = 1;
      let currentPage = page;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          usersData = response.data.data;
          total = usersData.length;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          usersData = response.data.data.data;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else if (response.data.data.users && Array.isArray(response.data.data.users)) {
          usersData = response.data.data.users;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            usersData = dataObj[arrayKeys[0]];
            total = dataObj.total || usersData.length;
            lastPage = dataObj.last_page || 1;
            currentPage = dataObj.current_page || page;
          } else {
            usersData = [dataObj];
            total = 1;
          }
        }
      } else if (Array.isArray(response.data)) {
        usersData = response.data;
        total = usersData.length;
      }

      setUsers(usersData);
      setTotalUsers(total);
      setTotalPages(lastPage);
      setCurrentPage(currentPage);

    } catch (error) {
      console.error("Error searching users:", error);
      setUsers([]);
      setTotalPages(1);
      setCurrentPage(1);
      setTotalUsers(0);
    } finally {
      setSearchLoading(false);
      setLoading(false);
    }
  };




    const fetchContinents = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${BASE_URL1}/continents`, {
          headers: {
                   'Authorization': `Bearer ${TOKEN}`,
                   'Content-Type': 'application/json'
               },
              } 
        );
  
        // console.log(response);
        const results = response.data?.data;
        setTableData(results);
        // console.log(results);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Redirect to login page if unauthorized
          navigate('/login');
        }else{
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                  errorMessage = JSON.stringify(error.response.data.message);
              }
          }
        setTableData([]);
        }
      } finally {
        setIsLoading(false);
      }
    };
  
    
   
  
  
  
    useEffect(() => {
      if (TOKEN) {
        fetchContinents();
      
      }
    }, [TOKEN]);

  const fetchProvinces = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );
      console.log(response, "fullreponse");
      const provData = response?.data.data || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvinces(options);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    } finally {
      setProvLoading(false);
    }
  };



  const fetchProvincesModal = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );

      console.log("Provinces Modal Response:", response);
      const provData = response?.data?.data  || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvincesModal(options);
    } catch (error) {
      console.error("Error fetching provinces for modal:", error);
      setProvincesModal([]);
    } finally {
      setProvLoading(false);
    }
  };

  // Filter handlers
  // const handleContinentChange = (selectedOption) => {
  //   console.log(selectedContinent)
  //   setSelectedContinent(selectedOption.id);
  //   setSelectedRegion(null);
  //   setSelectedProvince(null);

  //   if (selectedOption && selectedOption.value !== 'all') {
  //     fetchRegions(selectedOption.value);
  //   } else {
  //     setRegions([{ label: "All Regions", value: "all" }]);
  //   }
  // };

    const handleContinentChange = async (event) => {
    setSelectedContinent(event.target.value);
   setSelectedRegion("");
  }

  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption);
    setSelectedProvince(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvinces(selectedOption.value);
    } else {
      setProvinces([]);
    }
  };

  const handleProvinceChange = (selectedOption) => {
    console.log("Selected Province:", selectedOption);
    setSelectedProvince(selectedOption);
  };

  // Modal filter handlers
  const handleContinentChangeModal = (selectedOption) => {
    setSelectedContinentModal(selectedOption);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    if (selectedOption) {
    //   fetchRegionsModal(selectedOption.value);
    }
  };

  const handleRegionChangeModal = (selectedOption) => {
    console.log("Selected Region Modal:", selectedOption);
    setSelectedRegionModal(selectedOption);
    setSelectedProvinceModal(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvincesModal(selectedOption.value);
    } else {
      setProvincesModal([]);
    }
  };

  const handleProvinceChangeModal = (selectedOption) => {
    console.log("Selected Province Modal:", selectedOption);
    setSelectedProvinceModal(selectedOption);
  };

  const handleEyeClick1 = (id) => {
    setLoading(false);
    const foundRegion = tableData1.find(item => item.id === id);
    if (foundRegion) {
        console.log(foundRegion)
        const {description, continent} = foundRegion;
          setSelectedRegion(id);
          setDescription1(description || '');
          setSelectedContinent1(continent?.id || '');
        setShow1(true);
        // setEyeClicked(true);
    } else {
        console.error(`User with id ${id} not found`);
    }
};

const handleTrashClick1 = async (id) => {
    // 1. Ask for confirmation
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this region. This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33', // Red for delete
      cancelButtonColor: '#092147', // Your theme blue for cancel
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });
  
    // 2. If user clicks "Yes"
    if (confirmResult.isConfirmed) {
      try {
        const response = await axios.get(
          `${BASE_URL1}/regions/delete_region?id=${id}`, 
          {
            headers: {
              'Authorization': `Bearer ${TOKEN}`,
              'Content-Type': 'application/json'
            },
          }
        );
  
        // 3. Refresh the table
        fetchRegions();
  
        // 4. Show Success Alert
        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          text: response.data.message || 'The region has been deleted successfully.',
          confirmButtonColor: '#092147',
        });
  
      } catch (error) {
        // 5. Error Handling Logic
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        
        // Show Error Alert
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonColor: '#d33',
        });
      }
    } else {
      // 6. If user clicks "No"
      Swal.fire({
        icon: 'info',
        title: 'Cancelled',
        text: 'The deletion was cancelled.',
        confirmButtonColor: '#092147',
      });
    }
  };



  
  const createRegion = async () => {
     console.log(description1, selectedContinent);
    setCreateRegionLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL1}/regions/create_region`,
        {
          description: description1,
          continent_id: selectedContinent,
        },
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            'Content-Type': 'application/json'
          },
        }
      );

      // 1. Close the modal
      handleClose();

      // 2. Refresh the table data (Function requested)
      if (typeof tableData1 === 'function') {
          tableData1(); 
      }

      // 3. Show Success Alert
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message || 'Region created successfully!',
        confirmButtonColor: '#092147', // Matches your button theme
      });
      fetchRegions()

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      
      // Your existing error parsing logic
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Show Error Alert
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
        confirmButtonColor: '#d33',
      });

    } finally {
      setCreateRegionLoading(false);
    }
  };

  // Fetch user types for dropdown
  const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
      const typeList = response.data?.data;
      setUserType(typeList);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching user types:", error);
        setUserType([]);
      }
    } finally {
      setIsLoading(false);
    }
  };


  // Reset form
  // const resetNewUserForm = () => {
  //   setFullName("");
  //   setEmail("");
  //   setPhone("");
  //   setSelectedType("");
  //   setModalError("");
  //   setSelectedContinentModal(null);
  //   setSelectedRegionModal(null);
  //   setSelectedProvinceModal(null);
  //   setRegionsModal([]);
  //   setProvincesModal([]);
  // };

  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    resetNewUserForm();
  };

  const handleShowCreateUserModal = () => {
    setShowCreateUserModal(true);
    setModalError("");
  };

  // Prepare user type options
  const userTypeOptions = userTypes.map(userType => ({
    value: userType.id,
    label: userType.name || userType.description || `Role ${userType.id}`,
    ...userType
  }));

  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 6 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            {/* <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td> */}
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };

  const fetchPermission = async () => {
    setPermLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/role/permissions`, { headers });
      const data = response.data?.data;
      const permissionId = data.map(item => item.id);
      setPermId(permissionId);

      const initialToggleStates = Object.fromEntries(data.map(item => [item.id, false]));

      setPermissions(data);
      setToggleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setPermissions([]);
    } finally {
      setPermLoading(false);
    }
  };

  const fetRoles = async () => {
    setRoleLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/role/full-permissions`, { headers });
      const data = response.data?.data;
      const rolessId = data.map(item => item.id);
      setRoleID(rolessId);

      const initialToggleStates = Object.fromEntries(data.map(item => [item.id, false]));

      setRoles(data);
      setRoleStates(initialToggleStates);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setRoles([]);
    } finally {
      setRoleLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchPermission();
      fetRoles();
    }
  }, [bearer]);

  // Your existing toggle handlers...
  const handleToggleChange = (itemId) => {
    setToggleStates(prevToggleStates => ({
      ...prevToggleStates,
      [itemId]: !prevToggleStates[itemId],
    }));
  };

  const handleRoleToggleChange = (itemId) => {
    setRoleStates(prevRoleStates => {
      const updatedStates = {
        ...prevRoleStates,
        [itemId]: !prevRoleStates[itemId],
      };
      const allChecked = roles.every(role => updatedStates[role.id]);
      setRoleCheckAll(allChecked);
      const noneChecked = roles.every(role => !updatedStates[role.id]);
      if (noneChecked) setRoleCheckAll(false);
      return updatedStates;
    });
  };

  const handleCheckAllToggle = () => {
    const checkAllValue = !checkAll;
    setCheckAll(checkAllValue);
    const updatedToggleStates = Object.fromEntries(permissions.map(permission => [permission.id, checkAllValue]));
    setToggleStates(updatedToggleStates);
  };

  const handleCheckAllRoles = () => {
    const checkAllRoleValue = !roleCheckAll;
    setRoleCheckAll(checkAllRoleValue);
    const updatedToggleStates = Object.fromEntries(roles.map(role => [role.id, checkAllRoleValue]));
    setRoleStates(updatedToggleStates);
  };

  const [createLoading, setCreateLoading] = useState(false);


  const toIdArray = (val, key = "id") => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(x => (typeof x === "object" ? x[key] : x));
    if (typeof val === "object" && Array.isArray(val[key])) return val[key];
    if (typeof val === "number" || typeof val === "string") return [Number(val)];
    return [];
  };

  const asToggleMap = (allIds, selectedIds) =>
    Object.fromEntries(allIds.map(id => [id, selectedIds.includes(id)]));

  const handleOpenEdit = async (user) => {
    setEditingUser(user);

    // Basic info
    setFullName(user.name || user.full_name || "");
    setEmail(user.email || "");
    setPhone(user.phone_number || user.phone || "");
    setSelectedType(String(user.user_type_id || user.type_id || user.type || ""));

    // Set React Select values for modal
    if (user.continent_id || user.continent?.id) {
      const continentOption = continents.find(c => c.value == user.continent_id || c.value == user.continent?.id);
      setSelectedContinentModal(continentOption);
      if (continentOption) {
        // await fetchRegionsModal(continentOption.value);
      }
    }

    if (user.region_id || user.region?.id) {
      const regionOption = regionsModal.find(r => r.value == user.region_id || r.value == user.region?.id);
      setSelectedRegionModal(regionOption);
      if (regionOption) {
        await fetchProvincesModal(regionOption.value);
      }
    }

    if (user.province_id || user.province?.id) {
      const provinceOption = provincesModal.find(p => p.value == user.province_id || p.value == user.province?.id);
      setSelectedProvinceModal(provinceOption);
    }

    // Modules and Roles
    const userModuleIds = toIdArray(user.modules) || toIdArray(user.module_ids) || toIdArray(user.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));

    const userRoleIds = toIdArray(user.roles) || toIdArray(user.role_ids) || toIdArray(user.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));

    setShow1(true);
  };
  // Update the reset function to include all fields
  const resetNewUserForm = () => {
    setFullName("");
    setFullName1("");
    setEmail("");
    setEmail1("");
    setPhone("");
    setPhone1("");
    setSelectedType("");
    setModalError("");
    setSelectedContinentModal(null);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    setToggleStates({});
    setRoleStates({});
    setCheckAll(false);
    setRoleCheckAll(false);
  };

  // const fetchAllZones = async (provinceID) => {
  //   setProvLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/provinces/getzonesprovince?province_id=${provinceID}`,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${TOKEN}`,
  //         },
  //       });

  //     // console.log(response);
  //     const subReg = response.data?.data;
  //     const options = subReg.map((item) => ({
  //       label: item.description,
  //       value: item.id,
  //     }));
  //     setZones(options);
  //     // console.log(subCont, "heeeer");
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data && error.response.data.message) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }
  //     setZones([]);
  //   } finally {
  //     setProvLoading(false);
  //   }
  // };

  // const fetchAllAreas = async () => {
  //   setAreaLoad(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/zones/getareaszone?zone_id=${provinceID}`,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${TOKEN}`,
  //         },
  //       // });
  //       });

  //     // console.log(response);
  //     const subReg1 = response.data?.data;
  //     const options1 = subReg1.map((item) => ({
  //       label: item.description,
  //       value: item.id,
  //     }));
  //     setAreas(options1);
  //     // console.log(subCont, "heeeer");
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data && error.response.data.message) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }
  //     setAreas([]);
  //   } finally {
  //     setAreaLoad(false);
  //   }
  // };

  // useEffect(() => {
  //   if (TOKEN && provinceID) {
  //     fetchAllAreas(provinceID);
  //   }
  // }, [TOKEN, provinceID]);

  const fetchAllZones = async (provinceID) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/provinces/getzonesprovince?province_id=${provinceID}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const zoneList = response.data?.data || [];
      const formatted = zoneList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setZones(formatted);
  
      // 🚀 After zones load, fetch areas for the first zone
      if (formatted.length > 0) {
        fetchAllAreas(formatted[0].value);
      }
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
          setZones([]);
        } finally {
      setProvLoading(false);
    }
  };
  
  /* -----------------------------------------------------------
     FETCH ALL AREAS — NOTE: must accept `zoneID`
  ----------------------------------------------------------- */
  const fetchAllAreas = async (zoneID) => {
    setAreaLoad(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/zones/getareaszone?zone_id=${zoneID}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const areaList = response.data?.data || [];
      const formatted = areaList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setAreas(formatted);
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
      setAreas([]);
    } finally {
      setAreaLoad(false);
    }
  };
  

  useEffect(() => {
    if (bearer && provinceID) {
      fetchAllZones(provinceID);
    }
  }, [TOKEN, provinceID]);

  const handleProcess = async () => {
    setProcessLoading(true);

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-type?continent_id=${continentID}&region_id=${regionID}&province_id=${provinceID}&page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        // params: {
        //   zone_id: zones.id || '',
        //   area_id: selectedArea || ''
        // }
      });

       const results = response.data?.data?.parishes?.data;
    //   setTableData(results);
      const resultx = response.data?.data?.parishes?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.parishes?.last_page || 1;
      setTotalPages(total);

      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Swal.fire({
      //   icon: 'error',
      //   title: 'Failed',
      //   text: errorMessage,
      // });
    } finally {
      setProcessLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN, continentID, regionID, provinceID) {
      handleProcess();
    }
  }, [TOKEN, continentID, regionID, provinceID]);

  const fetchRegions = async () => {
    setRegionLoading(true);
    try {
      const response = await axios.get(`${BASE_URL1}/regions`,
       { headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'application/json'
      }, 
    }
        );

      // console.log(response);
      const reg = response.data?.data?.regions;
      setTableData1(reg);
      // console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      }else{
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }
      setTableData1([]);
      }
    } finally {
      setRegionLoading(false);
    }
  };

  
  const fetchSubContinents = async (selectedContinent) => {
    // setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL1}/continents/getcontinentregions?continent_id=${selectedContinent}`, 
        { 
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            'Content-Type': 'application/json'
        }, 
      }
        );

      // console.log(response);
      const subCont = response.data?.data;
      // setTableData3(subCont);
      // console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      }else{
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }
      // setTableData3([]);
      }
    } finally {
      // setLoad(false);
    }
  };

  useEffect(() => {
    if (TOKEN && selectedContinent) {
      fetchSubContinents(selectedContinent);
    }
  }, [TOKEN, selectedContinent]);



  useEffect(() => {
    if (TOKEN) {
      fetchContinents();
      fetchRegions();
      

    }
  }, [TOKEN]);


   const handleAreaProcess = async () => {
    setLoading(true);
  

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/get-all?page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        params: {
          zone_id: selectedZone || '',
          area_id: selectedArea || ''
        }
      });

      const results = response.data?.data?.data;
    //   setTableData(results);
      const resultx = response.data?.data?.data?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.data?.last_page || 1;
      setTotalPages(total);

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };



  // FIXED: Use permissions state instead of undefined variable
  useEffect(() => {
    if (!editingUser || !permissions.length) return;
    const userModuleIds = toIdArray(editingUser.modules) || toIdArray(editingUser.module_ids) || toIdArray(editingUser.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));
  }, [permissions, editingUser]);

  useEffect(() => {
    if (!editingUser || !roles.length) return;
    const userRoleIds = toIdArray(editingUser.roles) || toIdArray(editingUser.role_ids) || toIdArray(editingUser.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));
  }, [roles, editingUser]);


  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handleViewFixed = async (id) => {
    setSelectedItemId(id);
    setViewLoading(true);
    console.log(id);
    try {
      const response = await axios.get(`${BASE_URL1}/fixedassets/get-by-type?parish_id=${id}`,

        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`
          }
        });

      const instructionData1 = response.data?.data?.assets?.data;
      setResponseData(instructionData1);
      const resultx = response.data?.data?.assets?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.assets?.last_page || 1;
      setTotalPages(total);
      console.log(instructionData1, "Am here")

      navigate('/fixed_assets_registers', { state: { parishID: id } });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

    } finally {
      setViewLoading(false);
    }
  }

const editRegion = async () => {
    setLoading(true);
    console.log(description1, selectedContinent1, selectedRegion);

    try {
        const response = await axios.post(
            `${BASE_URL1}/regions/update_region`,
            {
                description: description1,
                continent_id: selectedContinent1,
                id: selectedRegion,
                // accountant_name: accountantName1,
                // accountant_email: accountantEmail1,
                // accountant_phone_number: accountantPhone1
            },
            {
                headers: {
                    'Authorization': `Bearer ${TOKEN}`,
                    'Content-Type': 'application/json'
                },
            }
        );

        fetchRegions();
        handleClose1();

        // Success Alert
        Swal.fire({
            icon: 'success',
            title: 'Updated!',
            text: response.data.message || 'Region updated successfully',
            confirmButtonColor: '#3085d6',
        });

    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
                errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
                errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
                errorMessage = JSON.stringify(error.response.data.message);
            }
        }

        // Error Alert
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            confirmButtonColor: '#d33',
        });

    } finally {
        setLoading(false);
    }
};

      const handleContinentChange1 = (event) =>{
    setSelectedContinent1(event.target.value)
  }
  const datatoRender = tableData1;
  const showCreateModalHandler = () => {
     setSelectedContinent("");
      setDescription1("");
      setShow(true)
  }


  return (
    <div>
      <HeaderNav />

   <Modal show={show} onHide={handleClose} animation={false} centered>
    <Modal.Header closeButton>
      <Modal.Title>Add Region</Modal.Title>
    </Modal.Header>
    
    <Modal.Body>
      <Form style={{ marginTop: 20 }}>
        <Form.Group className="mb-3" controlId="regionForm.ControlInput1">
          
          {/* Continent Select */}
          <Form.Label>Continents</Form.Label>
          <Form.Select
            className="form-control"
            value={selectedContinent}
            onChange={handleContinentChange}
          >
            <option value="" disabled>Select Continent</option>
            {tableData.map((item) => (
              <option key={item.id} value={item.id}>
                {item.description}
              </option>
            ))}
          </Form.Select>
          
          <div style={{ marginTop: 20 }} />

          {/* Description Input */}
          <Form.Label>Description</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Description"
            value={description1}
            onChange={(e) => setDescription1(e.target.value)}
          />

        </Form.Group>
      </Form>
    </Modal.Body>

    <Modal.Footer>
      <Button variant="danger" onClick={handleClose}>
        Go back
      </Button>
      <Button style={{ 
        borderRadius: 5, 
        background: "#092147", 
        color: '#ffffff',
        border: 'none'
      }} onClick={createRegion} disabled={createRegionLoading}>
        {createRegionLoading ? (
          <>
            <Spinner size='sm' animation="border" role="status" /> 
            <span style={{ marginLeft: '5px' }}>Creating...</span>
          </>
        ) : (
          "Create Region"
        )}
      </Button>
    </Modal.Footer>
  </Modal>

    <Modal show={show1} onHide={handleClose1} animation={false}>
                        <Modal.Header closeButton>
                          <Modal.Title>Edit Region</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form style={{ marginTop: 20 }}>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
  
                            <Form.Label>Continents</Form.Label>
  
                                <Form.Select
                                  className="form-control"
                                  value={selectedContinent1}
                                  onChange={handleContinentChange1}
                                >
                                  <option value="" disabled>Select Continent</option>
                                  {tableData.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.description}
                                    </option>
                                  ))}
                                </Form.Select>
                              
                              <div style={{ marginTop: 10 }} />
                              <Form.Label>Description</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Discription"
                                
                                value={description1}
                                onChange={(e) => setDescription1(e.target.value)}
                              />
                               {/* <div style={{ marginTop: 10 }} />
                              <Form.Label>Accountant Name</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Accountant Name"
                                
                                value={accountantName1}
                                onChange={(e) => setAccountantName1(e.target.value)}
                              /> */}
                              {/* <div style={{ marginTop: 10 }} />
                              <Form.Label>Accountant Phone Number</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Accountant Phone Number"
                                
                                value={accountantPhone1}
                                onChange={(e) => setAccountantPhone1(e.target.value)}
                              /> */}
                              {/* <div style={{ marginTop: 10 }} />
                              <Form.Label>Accountant Email Address</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Accountant Email Address"
                                
                                value={accountantEmail1}
                                onChange={(e) => setAccountantEmail1(e.target.value)}
                              />          */}
                              
                            </Form.Group>
                          </Form>
                        </Modal.Body>
  
  
  
  
  
  
                                <Modal.Footer>
                                  <Button variant="danger" onClick={handleClose1}>
                                    Go back
                                  </Button>
                                  
                                  <Button  onClick={editRegion}  style={{ 
        borderRadius: 5, 
        background: "#092147", 
        color: '#ffffff',
        border: 'none'
      }}>
                                    {loading ? ( <> <Spinner  size='sm' />
                                      <span style={{ marginLeft: '5px' }}>
                                        Editing region, Please wait...
                                      </span>
                                      </>) : ("Save Changes")}
                                  </Button>
                              </Modal.Footer>
                            </Modal>
  

      {/* Main Content */}
      <div className={classes.topContainer}>
        {/* <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remittances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Ledger</Button>
        </div> */}

        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Manage Region</h3>
        <p className={classes.prgText}>View All Region.</p>

      <div 
  className={classes.subContainer} 
  style={{ 
    display: 'flex', 
    justifyContent: 'flex-end', // Pushes content to the right
    alignItems: 'center',       // Keeps it vertically centered
    marginTop: '30px',
    marginBottom:'30px',
    paddingRight: '0px'        // Optional: Adds a little space from the edge
  }}
>
  <Button
    style={{ 
      borderRadius: 5, 
      background: "#092147", 
      color: '#ffffff',
      border: 'none'
    }} 
    onClick={showCreateModalHandler} // This triggers the modal
  >
    Add New Region
  </Button>
</div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>S/N</th>
                  <th>Region</th>
                    <th>Continent</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    {/* <th>Province</th> */}
                   {/* <th>Area</th>
                  <th>Zone</th> */}
                    <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {regionLoading ? (
                <SkeletonLoader />
              ) : datatoRender.length > 0 ? (
                datatoRender.map((item, index) => (
                  <tr style={{fontSize: "12px"}} key={item.id || index}>
                    
                  <td>{index + 1}</td>
                                                <td>{item.description}</td>
                                                <td>{item.continent?.description}</td>
                                                <td>{formatDate(item.created_at)}</td>
                                                <td>{formatDate(item.updated_at)}</td>
                                                {/* <td>{item.province?.description}</td>
                                        <td>{item.area?.description}</td>
                                        <td></td> */}
                                                <td style={{ whiteSpace: 'nowrap' }}>

                                                 <div onClick={() => handleEyeClick1(item.id)} className="btn btn-success-soft btn-sm mr-1">
                                          {/* <i className="far fa-eye" style={{color: "#008a4b", backgroundColor: "#28a7451a", padding: 2, borderColor: "#28a7454d", borderRadius: 5, fontSize:12}}></i> */}
                                          <img src={EyeIcon} />
                                          </div>
                                          <div onClick={() => handleTrashClick1(item.id)} className="btn btn-danger-soft btn-sm">
                                          {/* <i className="far fa-trash-alt"  style={{color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize:12}}></i> */}
                                          <img src={DeleteIcon} />
                                          </div>

                                                </td>
                  </tr>
                ))
              ) : (
                <tr style={{fontSize: "12px"}}>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {"No region available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={"handleFirstPage"}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => "handlePageClick"(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={"handleLastPage"}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalUsers)} of {totalUsers} users
          </p>
        </div>
      </div>
    </div>
  )
}

export default AdminRegion;